import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'
import { useMemo } from 'react'

import ProductGameTile from 'containers/ProductGameTile'
import useGames from 'src/hooks/useGames'

export type Props = {
  gameCodes: string
}

export default function GamesByIdContainer(props: Props) {
  const { allVisibleGames } = useGames()

  const filteredGameTiles = useMemo(() => {
    const hasGameCodes = props.gameCodes && props.gameCodes.length > 0
    const dividedGameCodes = hasGameCodes ? props.gameCodes.split(',').map((code) => code.trim()) : []

    if (dividedGameCodes.length === 0) {
      return []
    }

    const matchedGames = allVisibleGames.filter((game: GameProduct) => dividedGameCodes.includes(game.code))

    return matchedGames.length > 0
      ? matchedGames.map((game, index) => <ProductGameTile game={game} key={game.code} gameIndex={index + 1} />)
      : []
  }, [allVisibleGames, props.gameCodes])

  return <div className='grid items-start gap-2 px-4 pb-4 grid-cols-3 lg:grid-cols-5'>{filteredGameTiles}</div>
}
